import classNames from 'classnames';

import { ReactComponent as PlusIcon } from '@crazyegginc/hatch/dist/images/icon-plus.svg';

export function StepButton({ text, onClick, blueShadow }) {
  return (
    <button
      onClick={onClick}
      type="button"
      className={classNames(
        'h-10 rounded-[5px] text-dodger-blue-500 w-full flex justify-start items-center pl-5 font-semibold text-sm bg-white',
        'border border-mystic-500 hover:border-dodger-blue-500 focus-visible:border-dodger-blue-500',
        'transition active:scale-[.99]',
        'first:mt-0 mt-2.5',
        {
          'ring-1 ring-dodger-blue-300 shadow-sm shadow-dodger-blue-500/50 !border-dodger-blue-500': blueShadow,
          shadow: !blueShadow,
        },
      )}
    >
      <div className="flex items-center justify-center w-5 h-5 bg-solitude-500 mr-2.5 rounded">
        <PlusIcon className="w-2.5 h-2.5 fill-current" />
      </div>
      <span>{text}</span>
    </button>
  );
}
